"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSecurityHeaders = exports.setNoCacheHeaders = exports.setResponseHeaders = exports.getDeviceTypeFromRequestHeaders = void 0;
const web_headers_1 = require("@snapchat/web-headers");
const web_i18n_1 = require("@snapchat/web-i18n");
const requests_1 = require("./requests");
/**
 * Read the device type from GCP or Cloudfront headers.
 * Default to mobile if neither's present as traffic is 80+% mobile.
 */
const GCP_DEVICE_TYPE_HEADER_KEY = "x-gcp-device-type";
const CLOUDFRONT_IS_MOBILE_HEADER_KEY = "cloudfront-is-mobile-viewer";
function getDeviceTypeFromRequestHeaders(req) {
    let deviceType = "undetermined";
    if (!req?.headers) {
        // if CDN doesn't provide this, assume `undetermined` which is treated as mobile.
        return deviceType;
    }
    // Parse device type from GCP headers when that's available.
    // https://docs.google.com/document/d/1jx56lNRF7KFzvAhrc-13IpZ7w62Ti7vLRUAhH96Wr7s/edit
    // Potential values: https://grafana-dashboard.sc-corp.net/d/dweb_file_server_metrics/desktop-web-file-server?orgId=1&editPanel=59
    if (req.headers[GCP_DEVICE_TYPE_HEADER_KEY] !== undefined) {
        deviceType = req.headers[GCP_DEVICE_TYPE_HEADER_KEY];
    }
    else if (req.headers[CLOUDFRONT_IS_MOBILE_HEADER_KEY] !== undefined) {
        // Fallback to the cloudfront header if that doesn't exist.
        deviceType = req.headers[CLOUDFRONT_IS_MOBILE_HEADER_KEY] === "true" ? "mobile" : "desktop";
    }
    return deviceType.toLowerCase();
}
exports.getDeviceTypeFromRequestHeaders = getDeviceTypeFromRequestHeaders;
function setResponseHeaders(requestID, req, res, policyDirectives, stopCachingOnRequestsWithoutLocale, 
/**
 * How long to cache the response for in minutes.
 * Defaults to 5.
 */
maxAgeMins = 5) {
    if (req && res) {
        setSecurityHeaders(res, policyDirectives);
        (0, requests_1.setRequestIDIfPresent)(requestID, res);
        /**
         * For pages behind APIGW, APIGW doesnt add accept-lang header in the cache key (due to its high cardinality).
         * This means if we cache all requests, theoretically someone can get back the response in some other locale
         * just because that response was the latest cached one
         *
         * In such cases, we decided to not cache requests that do not have locale in their URL or sc-language cookie.
         * We can do so by not adding cache headers in the response.
         */
        if (stopCachingOnRequestsWithoutLocale && !(0, web_i18n_1.hasLocale)(req)) {
            (0, web_i18n_1.setSCLanguageCookieHeader)(req, res);
            setNoCacheHeaders(res);
        }
        else {
            setCacheHeaders(res, maxAgeMins);
        }
    }
}
exports.setResponseHeaders = setResponseHeaders;
function setCacheHeaders(res, maxAgeMins) {
    const maxAgeSecs = maxAgeMins * 60;
    const cacheControl = `public,max-age=${maxAgeSecs}`;
    // next.js generates the ETag header for us:
    //  https://nextjs.org/docs/api-reference/next.config.js/disabling-etag-generation
    res.setHeader("Cache-Control", cacheControl);
    // Vary on device type (gcp) / is mobile (Cloudfront) so we maintain a separate cache for mobile v desktop
    res.setHeader("Vary", [GCP_DEVICE_TYPE_HEADER_KEY, CLOUDFRONT_IS_MOBILE_HEADER_KEY].join(", "));
}
function setNoCacheHeaders(res) {
    // Ask to not cache the page
    res.setHeader("Cache-Control", "max-age=0,no-cache,no-store");
}
exports.setNoCacheHeaders = setNoCacheHeaders;
// TODO: consider https://github.com/jagaapple/next-secure-headers
function setSecurityHeaders(res, policyDirectives) {
    res.setHeader("X-Frame-Options", "DENY");
    res.setHeader("X-XSS-Protection", "0");
    res.setHeader("Content-Security-Policy", (0, web_headers_1.generateCSPHeaderValue)(policyDirectives));
    res.setHeader("Strict-Transport-Security", "max-age=31536000"); // 1 year in seconds
}
exports.setSecurityHeaders = setSecurityHeaders;
//# sourceMappingURL=responses.js.map